import React, {useCallback, useMemo, useState} from "react";
import Grid from "@mui/material/Grid";
import CandidateHeader from "../Candidate/CandidateHeader"
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import ApplicationScoring from "../ApplicationScoring";
import Notes from "../Candidate/Notes";
import {useLocation} from "react-router-dom";
import Emails from "./Emails";
import Documents from "./Documents"

function CustomTabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div role="tabpanel"
             hidden={value !== index}
             id={`simple-tabpanel-${index}`}
             aria-labelledby={`simple-tab-${index}`}
             {...other}>

            {value === index && (
                <div className="p-4" data-testid={`simple-tab-${index}`}>
                    {children}
                </div>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function CandidateView() {
    const [value, setValue] = useState(0);
    const [score, setScore] = useState(null);
    const [status, setStatus] = useState(null);

    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const candidateCvId = searchParams.get('candidateCvId');
    const candidateId = searchParams.get('candidateId');

    const handleChange = useCallback((event, newValue) => {
        setValue(newValue);
    }, []);

    const handleScoreUpdate = useCallback((newScore) => {
        setScore(newScore);
    }, []);

    const handleStatusUpdate = useCallback((newStatus) => {
        setStatus(newStatus);
    }, []);

    const tabContents = useMemo(() => [
        { title: "Overview", content: <ApplicationScoring candidateId={candidateCvId} onScoreUpdate={handleScoreUpdate} status={status} /> },
        { title: "Emails", content: <Emails candidateId={candidateId} /> },
        { title: "Notes", content: <Notes candidateId={candidateId} /> },
        { title: "Documents", content: <Documents candidateId={candidateId} candidateCvId={candidateCvId} /> },
    ], [candidateCvId, candidateId, handleScoreUpdate, status]);

    return (
        <Box className="container-fluid" data-testid="candidate-view">
            <Grid container spacing={2} direction="row" justifyContent="flex-start" alignContent="center">
                <Grid item xs={12}>
                    <CandidateHeader
                        candidateId={candidateId}
                        candidateCvId={candidateCvId}
                        score={score}
                        onStatusUpdate={handleStatusUpdate}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Box className="mt-4" sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                        <Tabs
                            sx={{
                                '& .MuiTabs-indicator': {
                                    backgroundColor: 'transparent',
                                },
                                '& .Mui-selected': {
                                    backgroundColor: '#FFFFFF',
                                    fontWeight: '600 !important'
                                }
                            }}
                            value={value}
                            onChange={handleChange}
                            textColor="inherit"
                            variant="fullWidth"
                            centered
                            aria-label="Candidate Detail View"
                        >
                            {tabContents.map((tab, index) => (
                                <Tab
                                    sx={{ fontFamily: 'Michroma' }}
                                    key={index}
                                    label={tab.title}
                                    {...a11yProps(index)}
                                />
                            ))}
                        </Tabs>

                        <Box className="bg-white">
                            {tabContents.map((tab, index) => (
                                <CustomTabPanel key={index} value={value} index={index}>
                                    {tab.content}
                                </CustomTabPanel>
                            ))}
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}